module.exports = __webpack_public_path__ + "static/media/footer-logo.763f1f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer-logo.png
// module id = 295
// module chunks = 1